import type * as React from "react";
import { usePostHogIdentify } from "@/lib/hooks/use-posthog-identify";

export function PostHogIdentityProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  usePostHogIdentify();
  return <>{children}</>;
}
